<template>
  <div class="IssueCard-dialog">
    <Modal v-model="openIssueCard" class-name="IssueCard-modal" :footer-hide="true" :closable="true">
      <h2 class="dia-title">
        Issue Card
      </h2>
      <div class="input-warpper">
        <p>Address</p>
        <input v-model="toAddress" type="text">
      </div>
      <div class="btn-warpper">
        <button class="IssueCardBtn" @click="confirm">
          Confirm
        </button>
        <button class="IssueCardBtn" @click="openIssueCard = false">
          Cancel
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { purchaseTo } from '@/contactLogic/GenArt/index.js';
import { mapState } from 'vuex';
import event from '@/common/utils/event.js';
export default {
  data() {
    return {
      openIssueCard: false,
      toAddress: '',
      data: {},
    };
  },
  methods: {
    open(data) {
      console.log(data);
      this.data = {};
      this.data = data;
      this.openIssueCard = true;
    },
    async confirm() {
      try {
        const { to, library, account, chainID, projectId, pricePerTokenInWei, isPassport, passportId } = {
          to: this.toAddress,
          library: this.ethersprovider,
          account: this.ethAddress,
          chainID: this.ethChainID,
          projectId: this.data.project_id,
          pricePerTokenInWei: this.data.token_info?.PricePerTokenInWei,
          isPassport: false,
          passportId: 0,
        };
        const res = await purchaseTo({
          to,
          library,
          account,
          chainID,
          projectId,
          pricePerTokenInWei,
          isPassport,
          passportId,
        });
        this.$Notice.success({
          title: 'Transaction sent successfully',
          duration: 10,
        });
        this.openIssueCard = false;
        event.$emit('sendtx', [
          res,
          {
            okinfo: `Successful purchase`,
            failinfo: `Purchase failed`,
          },
        ]);
        // console.log({ res });
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed: {
    ...mapState(['ethersprovider', 'ethAddress', 'ethChainID']),
  },
};
</script>
<style lang="less" scoped>
.IssueCard-modal {
  color: #fff;
  .dia-title {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 24px;
  }
  .input-warpper {
    input {
      width: 100%;
      height: 40px;
      outline: none;
      font-size: 16px;
      margin-top: 10px;
      padding: 5px 10px;
      border-bottom: 1px solid #fff;
      background: transparent;
    }
  }
  .btn-warpper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .IssueCardBtn {
      width: 45%;
      outline: none;
      cursor: pointer;
      font-size: 16px;
      margin-top: 30px;
      padding: 8px 0px;
      border: 1px solid #fff;
      border-radius: 4px;
    }
  }
}
</style>